import moment from 'moment'

export const videoHasProcessed = timestamp =>
  moment(moment.utc()).isAfter(moment.utc(timestamp).add(5, 'minutes'))
